
































import { Component, Vue } from 'vue-property-decorator';
import AdminPasswordPanel from '@/components/Admin/Panels/Profile/AdminPasswordPanel.vue';
import AdminProfilePanel from '@/components/Admin/Panels/Profile/AdminProfilePanel.vue';
import AdminNotificationPanel from '@/components/Admin/Panels/Profile/AdminNotificationPanel.vue';

@Component({
    components: {
        AdminPasswordPanel,
        AdminProfilePanel,
        AdminNotificationPanel,
    },
})
export default class AdminProfiles extends Vue {
    public tabs: any = [
        { title: this.$t('general.profile', 'Profile') },
        { title: this.$t('general.password', 'Password') },
        { title: this.$t('general.notification', 'Notification') },
    ];
    public activeTab: number = 0;

    constructor() {
        super();
    }

    public changeTab(tabIndex: number) {
        this.activeTab = tabIndex;
    }
}
